/**
 * Launch-mode flags for the Smithy Browns customer-facing website.
 *
 * These booleans control public visibility of homepage/nav elements.
 * Admin functionality and data are ALWAYS available regardless of these flags.
 *
 * Independent flags let us switch sections on individually as we approach launch.
 */

// Controls the full public Menu experience:
//   - Menu nav item in header, mobile tabs and footer
//   - `/menu` route (redirects to `/` when false)
//   - "View Menu" CTA on the Hero
//   - "View on Menu" CTA inside each Featured Dish card
export const PUBLIC_MENU_ENABLED = true;

// Controls the homepage "A Taste of This Place" gallery section.
// Admin content-management for this section remains available on `/admin/taste`
// regardless of this flag. Kept independent from `PUBLIC_MENU_ENABLED` so the
// Menu can go live without exposing the gallery.
export const PUBLIC_TASTE_ENABLED = true;
